export default __webpack_public_path__ + "static/media/Engaging_01.0f4e5239.png";